<template>
  <div>
    <el-dialog
      title="订单退款"
      :visible.sync="dialogRefund"
      :modal="false"
      width="600px"
      top="25vh"
      @close="close"
      v-loading="loading">
      <div>
        <el-form ref="form" :model="entity" label-width="80px" :rules="rules">
          <el-form-item label="订单编号">
            <el-input disabled v-model="entity.orderNo"></el-input>
          </el-form-item >
          <el-form-item label="订单退款" prop="refundFlag" v-if="entity.refundFlag">
            <el-switch v-model="refundFlag"></el-switch>
          </el-form-item>
          <el-form-item label="退款金额" prop="refundAmount">
            <el-input :disabled="refundReadOnly" v-model="entity.refundAmount" placeholder="请输入退款金额"></el-input>
          </el-form-item>
          <el-form-item label="退款原因">
            <el-input :disabled="refundReadOnly" type="textarea" v-model="entity.refundReason" placeholder="请输入退款原因"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {employee, order} from '@/api'
import {today, yesterday} from '@/utils/constant'
import {checkMoney} from '@/utils'

export default {
  name: 'OrderAllVisit',
  props: {
    dialogRefund: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object
    }
  },
  watch: {
    refundFlag: function (val) {
      if (val) {
        this.rules = this.valRules
        this.refundReadOnly = false
      } else {
        this.rules = {}
        this.refundReadOnly = true
      }
    }
  },
  data () {
    let validate = {
      refundAmount: [
        { required: true, message: '请输入退款金额', trigger: 'blur' },
        {validator: checkMoney, trigger: 'blur'}
      ]
    }
    return {
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      rules: validate,
      valRules: validate,
      refundReadOnly: false,
      refundFlag: true
    }
  },
  methods: {
    async submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.loading = true
          let {code} = await order.updateOrderFromBasic({
            orderFormId: this.entity.orderFormId,
            refundReason: this.entity.refundReason,
            refundAmount: this.entity.refundAmount,
            refundFlag: this.refundFlag
          })
          this.loading = false
          this.close(true)
          if (code === 0) {
            let message = '退款成功！'
            if (!this.refundFlag) message = '已取消退款'
            this.$message({
              message: message,
              type: 'success'
            })
          } else {
            this.$message('网络错误，请稍后重试！')
          }
        }
      })
    },
    close (flush) {
      this.entities = {}
      this.refundReadOnly = false
      this.refundFlag = true
      this.$emit('dialogRefund', false)
      if (flush) this.$emit('flush')
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    width: 70%
  }
  .el-input {
    width: 320px;
  }
  .el-date-editor {
    width: 320px !important;
  }
  .el-select {
    width: 320px;
  }
  .el-textarea {
    width: 320px;
  }
</style>
